import _ from 'lodash'
import { useWatch } from 'react-hook-form'

import { GameIcon } from '@/shared/ui/GameIcon'
import { useResourceContext } from '@/shared/ui/Resource'

import { itemPrice } from '../lib/redeemBlock'

export const DigitalProductStoreBottomSheetPrice = () => {
  const { reward_items } = useResourceContext()
  const selectedVariationId = useWatch({
    name: 'reward_item_id',
    defaultValue: null
  })

  // O preço vem da categoria da variação. Ler `coin` aqui mostrava "Grátis" em
  // item precificado, porque a coluna legada já não é preenchida.
  const prices = reward_items.map(itemPrice)
  const minPrice = prices.length ? Math.min(...prices) : 0
  const maxPrice = prices.length ? Math.max(...prices) : 0

  const selected = _.find(reward_items, item => item.id === selectedVariationId)
  // `!= null` e não truthy: preço zero é grátis de verdade e deve vencer o
  // intervalo, em vez de cair no fallback.
  const selectedPrice = selected ? itemPrice(selected) : null

  const label = () => {
    if (selectedPrice != null) return selectedPrice || 'Grátis'
    if (minPrice !== maxPrice) return `${minPrice} - ${maxPrice}`

    return minPrice || 'Grátis'
  }

  return (
    <div className="flex items-center justify-between">
      <div className="flex font-semibold text-sm">
        <span className="text-brand flex items-center hover:text-brand">
          <GameIcon name="coins" size={36} className="mr-2" />
          <span className="block font-extrabold text-3xl leading-none">
            {label()}{' '}
          </span>
        </span>
      </div>
    </div>
  )
}
